// extracted by mini-css-extract-plugin
module.exports = {"iconBox":"iconBox___1Lc8n","menuList":"menuList___3cM-1","menuItem":"menuItem___EjJfc","menuName":"menuName___2UgiU","tab8":"tab8___yLnd-"};